<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { TabsList, type TabsListProps } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<TabsListProps & { class?: HTMLAttributes["class"] }>()

const className = useClass(
	"inline-flex items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
	() => rawClass,
)
</script>

<template>
	<TabsList
		v-bind="props"
		:class="className">
		<slot />
	</TabsList>
</template>
